import { useTranslation } from 'react-i18next'

import { Tabs } from '../../../../tabs/Tabs'

import { PaymentMethod } from '../../../../../types/payment/payment'

type ManagementPaymentMethodTabsProps = {
  value: PaymentMethod
  disabled?: boolean
  onChange: (paymentMethod: PaymentMethod) => void
}

const ManagementPaymentMethodTabs = ({
  value,
  disabled = false,
  onChange,
}: ManagementPaymentMethodTabsProps) => {
  const { t } = useTranslation('bookings')

  // Bookings made for someone else are settled offline: the manager never pays by card for the customer.
  const options = [
    PaymentMethod.BANK_TRANSFER,
    PaymentMethod.CASH,
  ].map(paymentMethod => {
    const compactLabelKey =
      paymentMethod === PaymentMethod.BANK_TRANSFER
        ? 'booking.booking-courts.summary-panel.payment-method-bank-transfer-short'
        : paymentMethod === PaymentMethod.CASH
          ? 'booking.booking-courts.summary-panel.payment-method-cash-short'
          : undefined

    return {
      value: paymentMethod,
      label: compactLabelKey
        ? t(compactLabelKey)
        : t(
            `booking.all-booking-list.payment-method.${paymentMethod.toLowerCase()}`
          ),
    }
  })

  const label = t('booking.booking-courts.summary-panel.payment-method-label')
  const selectedLabel = options.find(option => option.value === value)?.label

  return (
    <div
      className="field summary-payment-method-control"
      role="group"
      aria-label={label}
    >
      <span className="eyebrow">{label}</span>
      <Tabs
        tab={value}
        tabs={options}
        disabled={disabled}
        className="summary-payment-method-tabs"
        onChange={selectedValue => onChange(selectedValue as PaymentMethod)}
      />
      <span className="visually-hidden" aria-live="polite">
        {label}: {selectedLabel}
      </span>
    </div>
  )
}

export default ManagementPaymentMethodTabs
